module.exports = __webpack_public_path__ + "static/media/cov-icon.5ac2c5e8.png";